import { TableCell } from "@mui/material";
import {
  Add,
  Check,
  Close,
  Create,
  Delete,
  History,
} from "@mui/icons-material";
import React from "react";
import { useTranslation } from "react-i18next";
import CustomFabButton from "../../components/Button/CustomFabButton";

export default function TableButtons(props) {
  const { t } = useTranslation("translation");
  return (
    <TableCell align="center" id="tb_actions">
      {props.editable &&
      props.editableRow === props.row.id &&
      !props.deleteCheckItem ? (
        <React.Fragment>
          <CustomFabButton
            id="tb_UpdateAdd"
            disabled={props.addDisabled}
            title={t("Confirm")}
            onClick={() => props.updateAddHandler(props.row)}
            icon={<Check />}
            color="primary"
            aria-label="add"
            style={{ marginRight: 5 }}
          />
          <CustomFabButton
            id="tb_DisableEdit"
            title={t("Cancel")}
            onClick={props.disableEditHandler}
            icon={<Close />}
            color="secondary"
            aria-label="edit"
            style={{ marginRight: 5 }}
          />
        </React.Fragment>
      ) : props.deleteCheckItem ? (
        <React.Fragment>
          <CustomFabButton
            id="tb_Delete"
            title={t("Delete")}
            onClick={() => props.deleteHandlerCheckItem(props.row)}
            icon={<Delete />}
            color="secondary"
            aria-label="delete"
            style={{ marginRight: 5 }}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          {props.table !== "SparePart" ? (
            <React.Fragment>
              {props.showHistory && (
                <CustomFabButton
                  id="tb_History"
                  title={t("History")}
                  onClick={() => props.showHistoryButtonHandler(props.row)}
                  icon={<History />}
                  color="secondary"
                  aria-label="delete"
                  style={{ marginRight: 5 }}
                />
              )}

              <CustomFabButton
                id="tb_EnableEdit"
                title={t("Edit")}
                onClick={() => props.enableEditHandler(props.row)}
                icon={<Create />}
                color="primary"
                aria-label="edit"
                style={{ marginRight: 5 }}
              />
              <CustomFabButton
                id="tb_Delete_2"
                title={t("Delete")}
                onClick={() => props.deleteButtonHandler(props.row)}
                icon={<Delete />}
                color="secondary"
                aria-label="delete"
                style={{ marginRight: 5 }}
              />
            </React.Fragment>
          ) : (
            <>
              <CustomFabButton
                id="tb_Delete_2"
                title={t("Delete")}
                onClick={() => props.deleteButtonHandler(props.row)}
                icon={<Delete />}
                color="secondary"
                aria-label="delete"
                style={{ marginRight: 35 }}
              />
            </>
          )}

          {props.detail === true ? (
            props.table === "CheckItemGroup" ? (
              <CustomFabButton
                id="tb_OpenDetail"
                title={t("AddCheckItem")}
                onClick={() => props.openDetailPage(props.row.id)}
                icon={<Add />}
                color="primary"
                aria-label="add"
                style={{
                  marginRight: 5,
                  backgroundColor: "#747474",
                }}
              />
            ) : (
              <CustomFabButton
                id="tb_OpenDetail_2"
                title={t("AddRelation")}
                onClick={() => props.openDetailPage(props.row.id)}
                icon={<Add />}
                color="primary"
                aria-label="add"
                style={{
                  marginRight: 5,
                  backgroundColor: "#747474",
                }}
              />
            )
          ) : props.table === "PlannedMaintenance" ? (
            <CustomFabButton
              id="tb_CreateCopy"
              title={props.title}
              onClick={() => props.navigateCreateCopy(props.row.id)}
              icon={props.icon}
              color="primary"
              aria-label="add"
              style={{
                marginRight: 5,
                backgroundColor: "#747474",
              }}
            />
          ) : null}
        </React.Fragment>
      )}
    </TableCell>
  );
}
